import React from "react";
import ListItem from "../../../components/ListItem";

const TasksListItem = (props) => {
  return (
    <>
      <ListItem
        key={props.key}
        listStyle={props.listStyle}
        id={props.task.id}
        overwriteClasses={props.overwriteClasses}
        elements={props.elements}
        dispatch={props.dispatch}
      />
    </>
  );
};

export default TasksListItem;
